import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import { useNavigate } from "react-router-dom";
import { Checkbox, ListItemText } from '@mui/material';



export const SelectColumnsButton = ({
    columns,
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    if (!Array.isArray(columns) || columns.length === 0) {
        return null
    }

    

    return (
        <Box sx={{
            width: '32px',
            height: '32px',
            padding: '0px',
            margin: '0px',

        }}>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                sx={{
                    width: '32px',
                    height: '32px',
                    padding: '0px',
                    margin: '0px',
                    '&:hover': {
                        backgroundColor: 'transparent'
                    }
                    ,
                    '&:focus': {
                        backgroundColor: 'transparent'
                    }

                }}
            >
                <SelectColumnsButtonIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}

            >

                {
                    columns.map((column, index) => {
                        return (
                            <MenuItem key={index} onClick={() => {
                                const { showColumn, setShowColumn, localStorageIndex } = column
                                setShowColumn(!showColumn);
                                localStorage.setItem(localStorageIndex, !showColumn);
                            }}>
                                <Checkbox checked={column.showColumn} />
                                <ListItemText primary={column.label} />
                            </MenuItem>
                        )
                    })
                }

            </Menu>
        </Box>
    );
}





const SelectColumnsButtonIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 16.625C0 17.1445 0.417969 17.5625 0.9375 17.5625H3.26953C3.66797 18.832 4.85156 19.75 6.25 19.75C7.64844 19.75 8.83203 18.832 9.23047 17.5625H19.0625C19.582 17.5625 20 17.1445 20 16.625C20 16.1055 19.582 15.6875 19.0625 15.6875H9.23047C8.83203 14.418 7.64844 13.5 6.25 13.5C4.85156 13.5 3.66797 14.418 3.26953 15.6875H0.9375C0.417969 15.6875 0 16.1055 0 16.625ZM5 16.625C5 16.2935 5.1317 15.9755 5.36612 15.7411C5.60054 15.5067 5.91848 15.375 6.25 15.375C6.58152 15.375 6.89946 15.5067 7.13388 15.7411C7.3683 15.9755 7.5 16.2935 7.5 16.625C7.5 16.9565 7.3683 17.2745 7.13388 17.5089C6.89946 17.7433 6.58152 17.875 6.25 17.875C5.91848 17.875 5.60054 17.7433 5.36612 17.5089C5.1317 17.2745 5 16.9565 5 16.625ZM12.5 10.375C12.5 10.0435 12.6317 9.72554 12.8661 9.49112C13.1005 9.2567 13.4185 9.125 13.75 9.125C14.0815 9.125 14.3995 9.2567 14.6339 9.49112C14.8683 9.72554 15 10.0435 15 10.375C15 10.7065 14.8683 11.0245 14.6339 11.2589C14.3995 11.4933 14.0815 11.625 13.75 11.625C13.4185 11.625 13.1005 11.4933 12.8661 11.2589C12.6317 11.0245 12.5 10.7065 12.5 10.375ZM13.75 7.25C12.3516 7.25 11.168 8.16797 10.7695 9.4375H0.9375C0.417969 9.4375 0 9.85547 0 10.375C0 10.8945 0.417969 11.3125 0.9375 11.3125H10.7695C11.168 12.582 12.3516 13.5 13.75 13.5C15.1484 13.5 16.332 12.582 16.7305 11.3125H19.0625C19.582 11.3125 20 10.8945 20 10.375C20 9.85547 19.582 9.4375 19.0625 9.4375H16.7305C16.332 8.16797 15.1484 7.25 13.75 7.25ZM7.5 5.375C7.16848 5.375 6.85054 5.2433 6.61612 5.00888C6.3817 4.77446 6.25 4.45652 6.25 4.125C6.25 3.79348 6.3817 3.47554 6.61612 3.24112C6.85054 3.0067 7.16848 2.875 7.5 2.875C7.83152 2.875 8.14946 3.0067 8.38388 3.24112C8.6183 3.47554 8.75 3.79348 8.75 4.125C8.75 4.45652 8.6183 4.77446 8.38388 5.00888C8.14946 5.2433 7.83152 5.375 7.5 5.375ZM10.4805 3.1875C10.082 1.91797 8.89844 1 7.5 1C6.10156 1 4.91797 1.91797 4.51953 3.1875H0.9375C0.417969 3.1875 0 3.60547 0 4.125C0 4.64453 0.417969 5.0625 0.9375 5.0625H4.51953C4.91797 6.33203 6.10156 7.25 7.5 7.25C8.89844 7.25 10.082 6.33203 10.4805 5.0625H19.0625C19.582 5.0625 20 4.64453 20 4.125C20 3.60547 19.582 3.1875 19.0625 3.1875H10.4805Z" fill="#364152" />
        </svg>

    )
}




